//populates full state name for state codes
var populateStates = (stateAssoc, stateAbbrev, stateAbbrevObj) => {
      $('#stores-state-select').empty().append('<option value=\'\'>Select a State</option>');
      for (var x = 0; x < stateAbbrevObj.length; x++) {
          for (var i = 0; i < stateAssoc.length; i++) {
              var test = stateAssoc[i].name;
              if (test == stateAbbrevObj[x])
                  $('#stores-state-select').append('<option value="' + stateAbbrevObj[x] + '">' + stateAssoc[i].name + '</option>');
          }
      }
  }
  //changes city location for each state
var storeCityChange = (storeLocations) => {
	  if ($('#stores-state-select').is(":visible")) {
	      var currentState = $('#stores-state-select').val();
	      //clear out recent states cities
	      $('#storeExperienceCities').empty().append('<option value=\'\'>Select a City</option>');
	      if ($('#stores-state-select').val() == '') {
	          $('.stores-city-select, #storeExperienceCities').attr("disabled", true).fadeTo(100, 0.7);
	      } else {
	          //populate cities per current state
	          for (var x = 0; x < storeLocations.length; x++) {
	              if (currentState == storeLocations[x].state)
	                  $('#storeExperienceCities').append('<option value="' + storeLocations[x].city + ' - ' + storeLocations[x].name + '" data-storenumber="' + storeLocations[x].number + '">' + storeLocations[x].city + ' - ' + storeLocations[x].name + '</option>');
	          }
	          $('.stores-city-select, #storeExperienceCities').attr("disabled", false).fadeTo(100, 1);
	      }
	  }
  }


export {populateStates,storeCityChange}
